import { Upload } from 'antd';
import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const UploadArea = styled(Upload.Dragger)`
  &.ant-upload.ant-upload-drag {
    background: transparent;
    border-radius: 4px;
    border: 1px dashed ${COLOR.IRON};
    width: 100%;
    height: 180px;

    .ant-upload.ant-upload-btn {
      padding: 25px;

      .ant-upload-drag-container {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
`;
